<div class="documents-header-container tw-flex tw-items-center tw-justify-between tw-pb-3 
            tw-border-b tw-border-solid tw-border-lendio-warm-gray-100">
    <div class="tw-flex tw-flex-row tw-items-center">
        <!-- Bulk actions -->
        @if (selectedRows.length) {
            <div [@fadeInOut] 
                 class="tw-flex tw-flex-row tw-items-center tw-justify-end tw-lendio-density-1">
                <button mat-stroked-button 
                        color="'accent'" 
                        class="tw-flex tw-flex-row tw-items-center tw-mx-1 tw-w-[100.33px]"
                        (click)="handleDownload($event)">
                    @if (isDownloading) {
                        <span class="spinner"></span>
                    } @else {
                        <span class="tw-text-lendio-warm-gray-900">Download</span>
                    }
                </button>
            </div>
        }
    </div>
    <!-- Upload -->
    <div class="tw-flex tw-items-center tw-justify-between tw-lendio-density-1">
        <button 
            mat-icon-button
            data-cy="refresh-documents-btn"
            [matTooltip]="'Refresh Documents'"
            color="'accent'" 
            class="tw-flex tw-flex-row tw-items-center" 
            [disabled]="refreshIsRotating"
            (click)="handleRefreshDocuments()">
            <mat-icon 
                class="tw-text-lendio-warm-gray-900 tw-mr-2 tw-material-icons-outlined" 
                iconPositionStart
                [@rotateIcon]="refreshIsRotating ? 'rotating' : 'normal'">refresh</mat-icon>
        </button>
        <button mat-stroked-button
                [matMenuTriggerFor]="documentsTab"
                [disabled]="!availableBorrowerDocuments.length"
                color="'accent'"
                [matTooltip]="availableBorrowerDocuments.length ? 
                              'Attach Borrower Documents' : 
                              'No Borrower Documents to Attach'"
                class="tw-flex tw-flex-row tw-items-center mr-2"
                [class.tw-opacity-50]="!availableBorrowerDocuments.length"
                [class.tw-cursor-not-allowed]="!availableBorrowerDocuments.length">
            <mat-icon class="tw-text-lendio-warm-gray-900 tw-mr-2 tw-material-icons-outlined" 
                      iconPositionStart>sync_alt</mat-icon>
            <span class="tw-text-lendio-warm-gray-900">Attach</span>
        </button>

        <!-- Attach Borrower Documents Menu -->
        <mat-menu #documentsTab="matMenu" class="documents-tab-options">
            <div class="docs-tab-options">
                <!-- Flat list with category headers as special items -->
                <button
                    *ngFor="let item of flattenedBorrowerDocuments"
                    mat-menu-item
                    class="document-item"
                    [class.category-header-item]="item.isCategory"
                    [disabled]="item.isCategory"
                    (click)="item.isCategory ? $event.stopPropagation() : $event.stopPropagation()">
                    
                    <!-- Category header -->
                    <div *ngIf="item.isCategory" class="category-header-content">
                        <span class="category-title" 
                              [style.font-weight]="'600'" 
                              [style.font-size]="'11px'" 
                              [style.text-transform]="'uppercase'" 
                              [style.letter-spacing]="'0.5px'">
                            {{ formatCategory(item.category) }}
                        </span>
                    </div>
                    
                    <!-- Document item -->
                    <mat-checkbox
                        *ngIf="!item.isCategory"
                        class="doc-checkbox small-checkbox"
                        (change)="toggleSelected(item, $event.checked)"
                        [checked]="docSelected(item)">
                        <span class="document-title-text" 
                              [style.word-wrap]="'break-word'" 
                              [style.word-break]="'break-word'" 
                              [style.overflow-wrap]="'break-word'" 
                              [style.max-width]="'300px'" 
                              [style.white-space]="'normal'">
                            {{ item.title }}
                        </span>
                    </mat-checkbox>
                </button>
            </div>
            <div mat-menu-item>
                <button
                    class="attach-docs"
                    mat-flat-button
                    color="primary"
                    (click)="attachSelected()"
                    [disabled]="!selectedDocuments.length">
                    Attach Selected 
                    <span *ngIf="selectedDocuments.length">({{ selectedDocuments.length }})</span>
                </button>
            </div>
        </mat-menu>

        <button mat-stroked-button 
                data-cy="upload-deal-doc-btn"
                color="'accent'"
                matTooltipShowDelay="500"
                class="tw-flex tw-flex-row tw-items-center"
                (click)="handleUpload()">
            <mat-icon class="tw-text-lendio-warm-gray-900 tw-mr-2 tw-material-icons-outlined" 
                      iconPositionStart>file_upload</mat-icon>
            <span class="tw-text-lendio-warm-gray-900">Upload</span>
        </button>
    </div>
</div>
